import { createSelector } from 'reselect';
import { initialState, initialAPIState } from './reducer';

const selectDomain = (state) => (state && state.formData) || initialState;
const selectFormType = (_, type) => type;

const selectState = createSelector(selectDomain, (state) => state.rates);

const selectFetchedSavesState = createSelector(selectDomain, selectFormType, (state, formType) =>
    state.fetchedSaves.filters.type === formType ? state.fetchedSaves : initialAPIState,
);

const selectLoadedSaveState = createSelector(selectDomain, (state) => state.loadedSave);

const selectFormSavingState = createSelector(selectDomain, (state) => state.formSave);

const selectCurrentlyLoadedSaveDetails = createSelector(selectDomain, (state) => state.currentSave);

export {
    selectState,
    selectCurrentlyLoadedSaveDetails,
    selectFetchedSavesState,
    selectLoadedSaveState,
    selectFormSavingState,
};
